import type { Reducer } from '@reduxjs/toolkit';
import { isNil } from 'lodash-es';
import React from 'react';
import type { InjectableReduxStore } from './configureInjectableStore';

export function useInjectableReducer(
  store: InjectableReduxStore,
  sliceName: string,
  reducer: Reducer
) {
  React.useLayoutEffect(() => {
    if (isNil(store.getState()[sliceName])) {
      store.injectReducer(sliceName, reducer);
    }
  }, [store, sliceName, reducer]);
}
